import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { inject, injectable } from "inversify";

@injectable()
export class FetchProviderMetadataUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) {}

    async execute(): Promise<any> {
        return this.budgetRepository.fetchProviderMetadata();
    }
}
